<div [id]="mapId" style="width:100%; height: 100%;" class="map-container">
    <!-- <div class="float-on-map">
        <div>
            <button class="button-general" (click)="openInArcMap()">ArcMap</button>
        </div>
    </div>     -->
</div>

<div class="zoom-level" title="Zoom Level">
    {{'ZL: ' + zoomLevel }}
</div>
<div id="map-scaleline"></div>


